import ErrorComponent from './error-component.jsx';

export default ErrorComponent;
